import { render } from "./LegalReviewComplete.vue?vue&type=template&id=1a043c59"
import script from "./LegalReviewComplete.vue?vue&type=script&lang=js"
export * from "./LegalReviewComplete.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__